import { Routes } from '@angular/router';
import { LayoutComponent } from '@pages/layout/layout.component';
import { authGuard, permissionGuard, tenantAccessGuard } from '@lib/guards';
import { Permission, TenantFlow } from '@lib/enums';
import { TermsAndConditionComponent } from '@lib/components/fib/terms-and-condition.component';

export const routes: Routes = [
    {
        path: 'auth/:tenant',
        loadChildren: async () => (await import('@pages/auth')).routes,
        canMatch: [authGuard({ requiresAuthentication: false })],
    },
    {
        path: 'terms-and-condition',
        component: TermsAndConditionComponent,
    },
    {
        path: '',
        component: LayoutComponent,
        canMatch: [authGuard()],
        children: [
            {
                path: '',
                loadChildren: async () => (await import('@pages/welcome-screen')).routes,
            },
            {
                path: 'report',
                data: { permission: [Permission.ProductManagement] },
                canActivate: [permissionGuard],
                loadChildren: async () => (await import('@pages/analytics')).routes,
            },
            {
                path: 'home',
                data: { permission: [Permission.AccessManagement] },
                canActivate: [permissionGuard],
                loadComponent: async () => (await import('@pages/home/home.component')).HomeComponent,
            },
            {
                path: 'customers',
                data: { permission: [Permission.Customer] },
                canActivate: [permissionGuard],
                loadChildren: async () => (await import('@pages/customer')).routes,
            },
            {
                path: 'agents',
                data: { permission: [Permission.Customer, Permission.AgentView] },
                canActivate: [permissionGuard],
                canMatch: [tenantAccessGuard(TenantFlow.AGENT_SEPARATE_MODULE)],
                loadChildren: async () => (await import('@pages/agent')).routes,
            },
            {
                path: 'card-product',
                data: { permission: [Permission.ProductManagement] },
                canActivate: [permissionGuard],
                loadChildren: async () => (await import('@pages/card-products')).routes,
            },
            {
                path: 'cards',
                canActivate: [permissionGuard],
                data: { permission: [Permission.CustomerCards] },
                loadChildren: async () => (await import('@pages/cards')).routes,
            },
            {
                path: 'call-center',
                data: { permission: [Permission.CallCenter] },
                canActivate: [permissionGuard],
                loadChildren: async () => (await import('@pages/call-center')).routes,
            },
            {
                path: 'faq',
                loadChildren: async () => (await import('@pages/faq')).routes,
            },
            {
                path: 'control-center',
                data: { permission: [Permission.Settings] },
                canActivate: [permissionGuard],
                loadChildren: async () => (await import('@pages/control-center')).routes,
            },
            {
                path: 'feedback',
                loadChildren: async () => (await import('@pages/feedback')).routes,
            },
            {
                path: 'access-management',
                data: { permission: [Permission.AccessManagement] },
                canActivate: [permissionGuard],
                loadChildren: async () => (await import('@pages/access-management')).routes,
            },
            {
                path: 'product-settings',
                data: { permission: [Permission.ProductSettings] },
                canActivate: [permissionGuard],
                loadChildren: async () => (await import('@pages/product-settings')).routes,
            },
            {
                path: 'transactions',
                data: { permission: [Permission.CustomerCards, Permission.CustomerCardsTransactions,Permission.Transactions] },
                canActivate: [permissionGuard],
                loadChildren: async () => (await import('@pages/transaction')).routes,
            },
            {
                path: 'bulk-upload-cash',
                data: { permission: [] },
                canActivate: [permissionGuard],
                loadChildren: async () => (await import('@pages/bulk-upload-cash')).routes,
            },
            {
                path: 'atm',
                data: { permission: [Permission.Locations] },
                canActivate: [permissionGuard],
                loadChildren: async () => (await import('@pages/atm')).routes,
            },
            {
                path: 'exchange-rate-managment',
                data: { permission: [Permission.FxRates] },
                canActivate: [permissionGuard],
                loadChildren: async () => (await import('@pages/exchange-rate-managment')).routes,
            },
            {
                path: 'customer-operations',
                data: { permission: [Permission.CardLessVouchers] },
                canActivate: [permissionGuard],
                loadChildren: async () => (await import('@pages/customer-operations')).routes,
            },
            {
                path: 'card-request',
                data: { permission: [Permission.CustomerCardRequest] },
                canActivate: [permissionGuard],
                canMatch: [tenantAccessGuard(TenantFlow.CARD_REQUEST_ACCESS_ALLOWED)],
                loadChildren: async () => (await import('@pages/card-request')).routes,
            },
            {
                path: 'user-requests',
                data: { permission: [Permission.UserExternal,Permission.UserRequests] },
                canActivate: [permissionGuard],
                canMatch: [tenantAccessGuard(TenantFlow.REQUESTS_MODULE_ALLOWED)],
                loadChildren: async () => (await import('@pages/user-requests')).routes,
            },
            {
                path: 'pending-requests',
                canMatch: [tenantAccessGuard(TenantFlow.PENDING_REQUESTS_MODULE)],
                loadChildren: async () => (await import('@pages/pending-requests')).routes,
            },
            {
                path: '**',
                redirectTo: ' ',
                pathMatch: 'full',
            },
        ],
    },
    { path: '**', pathMatch: 'full', redirectTo: '/auth/tenant1_api/login' },
];
